export function reminderLabel(m) {
  if (m === 0) return "At start";
  // Check weeks before days: a whole-week offset (e.g. 10080) is also a
  // multiple of 1440, so days must lose the tie or "1 week before" would
  // render as "7 days before".
  if (m % 10080 === 0) return `${m / 10080} week${m / 10080 > 1 ? "s" : ""} before`;
  if (m % 1440 === 0) return `${m / 1440} day${m / 1440 > 1 ? "s" : ""} before`;
  if (m % 60 === 0) return `${m / 60} hr${m / 60 > 1 ? "s" : ""} before`;
  return `${m} min before`;
}
export function formatReminders(arr) {
  if (!Array.isArray(arr) || !arr.length) return null;
  return [...arr].sort((a, b) => a - b).map(reminderLabel).join(", ");
}
export function durationLabel(start, end) {
  if (!start || !end) return null;
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  const total = (eh * 60 + em) - (sh * 60 + sm);
  if (total <= 0) return null;
  const h = Math.floor(total / 60), m = total % 60;
  return h > 0 ? (m > 0 ? `${h}h ${m}m` : `${h}h`) : `${m}m`;
}
